export default "__VITE_ASSET__BHsn1zQN__"